import { all, call, CallEffect, put, PutEffect, takeEvery } from 'redux-saga/effects';
import { RequestActionType, requestError, requestSuccess } from '../../actions/requestActions';
import {
    DeclineManagedByPartnerConsent,
    DeclineManagedByPartnerConsentSuccess,
    declineManagedByPartnerConsentSuccess,
    FetchUserInfo,
    fetchUserInfo,
    ConsentAction,
    GiveConsent,
    giveConsentSuccess,
    GiveConsentSuccess,
} from '../../actions/SettingsActions';

import { declineManagedByPartnerConsent, giveConsent } from '../../api/consent';
import RequestTypes from '../../models/RequestTypes';
import { CommonRequestType } from '../../reducers/requestReducer';
import { toErrorType } from '../isErrorType';

export function* declineManagedByPartnerConsentSaga({
    payload,
}: DeclineManagedByPartnerConsent): Generator<
    CallEffect | PutEffect<DeclineManagedByPartnerConsentSuccess> | PutEffect<FetchUserInfo> | RequestTypes
> {
    try {
        yield call(declineManagedByPartnerConsent, payload);
        yield put(requestSuccess(CommonRequestType.DeclineManagedByPartnerConsent, RequestActionType.Success));
        yield put(declineManagedByPartnerConsentSuccess());
        yield put(fetchUserInfo());
    } catch (error) {
        const asErrorType = toErrorType(error);
        yield put(requestError(asErrorType, CommonRequestType.DeclineManagedByPartnerConsent, RequestActionType.Error));
    }
}

export function* giveConsentSaga({
    payload,
}: GiveConsent): Generator<CallEffect | PutEffect<GiveConsentSuccess> | RequestTypes> {
    try {
        yield call(giveConsent, payload);
        yield put(requestSuccess(CommonRequestType.GiveConsent, RequestActionType.Success));
        yield put(giveConsentSuccess());
    } catch (error) {
        const asErrorType = toErrorType(error);
        yield put(requestError(asErrorType, CommonRequestType.GiveConsent, RequestActionType.Error));
    }
}

export default function* consentSagas(): Generator {
    yield all([
        yield takeEvery(ConsentAction.DeclineManagedByPartnerConsent, declineManagedByPartnerConsentSaga),
        yield takeEvery(ConsentAction.GiveConsent, giveConsentSaga),
    ]);
}
